import React from 'react';
import styles from './ADTporque.module.css';

const ADTporque = () => {
    const beneficios = [
        {
            icono: "src/icon1.png",
            titulo: "Líderes en seguridad",
            descripcion: "ADT es la empresa número 1º en Argentina en seguridad y sistemas de monitoreo para hogares y comercios."
        },
        {
            icono: "src/icon2.png",
            titulo: "Control 24hrs",
            descripcion: "Cuidamos tu casa o comercio las 24hs los 365 días del año con respuesta inmediata ante cualquier evento."
        },
        {
            icono: "src/icon3.png",
            titulo: "Planes con Descuento",
            descripcion: "Tu tranquilidad con planes súper completos desde $1.430 pesos por día."
        },
        {
            icono: "src/icon4.png",
            titulo: "Control desde tu celular",
            descripcion: "Cámaras en vivo, alertas, activación y desactivación del sistema, todo desde la app."
        }
    ];

    return (
        <div className={`${styles.section} section`}>
            <div className="container-lg flex flexCol alignCenter">
                <h2 className='textCenter'>
                    ¿Por qué elegir <span>ADT</span>?
                </h2>
                <div className={`flex flexRow space ${styles.boxes}`}>
                    {beneficios.map((item, index) => (
                        <div key={index} className={styles.box}>
                            <img src={item.icono} alt={`Ícono ${item.titulo}`} />
                            <h4>{item.titulo}</h4>
                            <p>{item.descripcion}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ADTporque;
